import { useContext } from 'react';
import type { ApiContextType } from './types';
import { ApiContext } from './context';

export const useApi = (): ApiContextType => {
    const context = useContext(ApiContext);
    if (!context) {
        throw new Error('useApi must be used within a ApiProvider');
    }
    return context;
};
